import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const relationsList = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetRelations}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useRelationQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetRelations],
    queryFn: () => relationsList(companyCode),
  });
};
